import { atom } from 'jotai';
import { ExplorerItem } from "@/types/types.ts";

export const currentExplorerItemAtom = atom<ExplorerItem | null>(null);
